import React from 'react';
import { GenericListPage } from '../../../components/generic';
import { useReminderTypes, ReminderType } from './useData';
import { moduleConfig, getColumns, getToolbarIcon, getTableActions } from './config';

const List: React.FC = () => {
  return (
    <GenericListPage<ReminderType>
      useData={useReminderTypes}
      config={{
        ...moduleConfig,
        getColumns,
        getToolbarIcon,
        getTableActions,
      }}
    />
  );
};

export default List;
